
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DateTime } from 'luxon';

import SalesInvoiceRows from './row/SalesInvoiceRows.vue';

import { sharedState } from '../../../../../framework/state';
import { getResource } from '../../../../../framework/client/resource';
import { getEnumerationOptions, getOptionLabel } from '../../../../../framework/service/options';

import { SalesInvoice } from '../../../../../../common/application/model/SalesInvoice';
import { getCustomerOptions } from '../../../../service/application_options_service';
import { SalesInvoiceState } from '../../../../../../common/application/model/enums/SalesInvoiceState';
import { PaymentTerms } from '../../../../../../common/application/model/enums/PaymentTerms';
import { SalesInvoiceType } from '../../../../../../common/application/model/enums/SalesInvoiceType';
import { ApplicationResource } from '../../../../../../common/application/enumeration/ApplicationResource';
import { dateToDbDateString } from '../../../../../../common/framework/util/convert';

@Component({
    components: { SalesInvoiceRows },
})
export default class ViewSalesInvoice extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.SALES_INVOICE;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        row: {} as SalesInvoice,
        salesInvoiceTypeOptions: [] as { id: string | undefined; label: string }[],
        salesInvoiceStateOptions: [] as { id: string | undefined; label: string }[],
        customerOptions: [] as { id: string | undefined; label: string }[],
        paymentTermsOptions: [] as { id: string | undefined; label: string }[],
        dueDate: '',
        entryDate: '',
        customer: '',
        salesInvoiceType: '',
        salesInvoiceState: '',
        paymentTerms: '',
    };

    // Functions
    async mounted() {
        this.local.customerOptions = await getCustomerOptions();
        this.local.salesInvoiceTypeOptions = getEnumerationOptions(
            'SalesInvoiceType',
            Object.keys(SalesInvoiceType),
            this,
        );
        this.local.salesInvoiceStateOptions = getEnumerationOptions(
            'SalesInvoiceState',
            Object.keys(SalesInvoiceState),
            this,
        );
        this.local.paymentTermsOptions = getEnumerationOptions('PaymentTerms', Object.keys(PaymentTerms), this);
        this.local.row = (await getResource<SalesInvoice>(this.resourceType, this.id))!!;

        this.local.dueDate = dateToDbDateString(
            DateTime.fromJSDate(new Date(this.local.row.dueDate), { zone: 'UTC' }).toJSDate(),
        );
        this.local.entryDate = dateToDbDateString(
            DateTime.fromJSDate(new Date(this.local.row.entryDate), { zone: 'UTC' }).toJSDate(),
        );

        this.local.customer = getOptionLabel(this.local.row.customerId, this.local.customerOptions);
        this.local.salesInvoiceType = getOptionLabel(
            this.local.row.salesInvoiceType,
            this.local.salesInvoiceTypeOptions,
        );
        this.local.salesInvoiceState = getOptionLabel(
            this.local.row.salesInvoiceState,
            this.local.salesInvoiceStateOptions,
        );
        this.local.paymentTerms = getOptionLabel(this.local.row.paymentTerms, this.local.paymentTermsOptions);
    }

    back() {
        this.$router.go(-1);
    }

    edit() {
        this.$router.push(`/sales-invoice/${this.local.row.id}/edit`);
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }
}
